import Vue from 'vue'
import VueRouter from 'vue-router'
import { getInfo } from '@/api/auth'
import { clearAuthState, getToken, setUserProfile } from '@/utils/auth'
import DashboardView from '@/views/index.vue'
import LoginView from '@/views/login.vue'
import NoticeView from '@/views/notice.vue'
import ApplicationView from '@/views/application.vue'

Vue.use(VueRouter)

const appTitle = '乌昌海关业务运行可视化'

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: {
        title: `前台登录 - ${appTitle}`
      }
    },
    {
      path: '/',
      name: 'dashboard',
      component: DashboardView,
      meta: {
        requiresAuth: true,
        title: appTitle
      }
    },
    {
      path: '/notice',
      name: 'notice',
      component: NoticeView,
      meta: {
        requiresAuth: true,
        title: `预警信息处置 - ${appTitle}`
      }
    },
    {
      path: '/application',
      name: 'application',
      component: ApplicationView,
      meta: {
        requiresAuth: true,
        title: `申请中心 - ${appTitle}`
      }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const token = getToken()
  if (to.path === '/login') {
    if (token) {
      next('/')
      return
    }
    next()
    return
  }

  if (!token) {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    })
    return
  }

  try {
    const info = await getInfo(token)
    setUserProfile({ ...(info.user || {}), roles: info.roles || [], permissions: info.permissions || [] })
  } catch {
    clearAuthState()
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    })
    return
  }

  next()
})

router.afterEach((to) => {
  document.title = to.meta.title || appTitle
})

export default router
